module.exports = __webpack_public_path__ + "622d7df8903032b24a8b68bfb253747a.png";